<div class="toast">
  @for (toast of toasts; track toast.id) {
    <div [id]="toast.id" class="toast__card toast__card--{{ toast.type }}" [class.toast__card--with-actions]="toast.actions && toast.actions.length > 0">
      <div class="toast__title">{{ toast.message }}</div>

      @if (toast.description) {
        <div class="toast__description">{{ toast.description }}</div>
      }

      @if (toast.actions && toast.actions.length > 0) {
        <div class="toast__actions">
          @for (action of toast.actions; track action.label) {
            <button 
              type="button" 
              class="toast__button toast__button--{{ action.type || 'secondary' }}"
              (click)="executeAction(action, toast.id)">
              {{ action.label }}
            </button>
          }
        </div>
      }

      @if (!toast.actions || toast.actions.length === 0) {
        <button type="button" class="toast__button toast__button--close" (click)="dismiss(toast.id)">
          Cerrar
        </button>
      }
    </div>
  }
</div>